import React from "react";

const MembershipIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5617,13.6442l-1.9202,0.3887l-1.4451,-2.2422c-0.0903,-0.1453 -0.2984,-0.1453 -0.3887,0l-1.4451,2.2422l-1.9202,-0.3887c-0.1767,-0.0354 -0.322,0.1335 -0.267,0.2984l1.0209,3.2907c0,0 0,0 0,-0.0039c0,-0.3573 1.2566,-0.6479 2.8038,-0.6479c1.5472,0 2.8077,0.2945 2.8077,0.6479l1.0209,-3.2907c0.051,-0.1649 -0.0904,-0.3338 -0.267,-0.2984z"
        fill="#1A8B5A"
      />
      <path
        d="M18.8077,17.2333c0,0.3613 -1.2566,0.6479 -2.8077,0.6479c-1.5511,0 -2.8038,-0.2905 -2.8038,-0.6479c0,-0.3573 1.2566,-0.6479 2.8038,-0.6479c1.5472,0 2.8077,0.2945 2.8077,0.6479z"
        fill="currentColor"
      />
      <path
        d="M10.4045,22.0633h-3.1022c-1.0328,0 -1.877,-0.8404 -1.877,-1.8771v-8.5329c0,-1.0328 0.8403,-1.877 1.877,-1.877h3.1022v0.9817h-3.1022c-0.4909,0 -0.8953,0.4006 -0.8953,0.8953v8.5329c0,0.4909 0.4005,0.8954 0.8953,0.8954h3.1022z"
        fill="currentColor"
      />
      <path
        d="M24.6984,22.0633h-3.1022v-0.9817h3.1022c0.4908,0 0.8953,-0.4005 0.8953,-0.8954v-8.5329c0,-0.4909 -0.4006,-0.8953 -0.8953,-0.8953h-3.1022v-0.9817h3.1022c1.0327,0 1.877,0.8404 1.877,1.877v8.5329c0,1.0328 -0.8404,1.8771 -1.877,1.8771z"
        fill="currentColor"
      />
      <path
        d="M20.2413,24.8435h-8.4781c-1.0327,0 -1.8771,-0.8404 -1.8771,-1.8771v-14.0896c0,-1.0327 0.8404,-1.877 1.8771,-1.877h8.4781c1.0327,0 1.877,0.8404 1.877,1.877v14.0896c0,1.0328 -0.8404,1.8771 -1.877,1.8771zM11.7593,7.9817c-0.4908,0 -0.8953,0.4006 -0.8953,0.8953v14.0896c0,0.4909 0.4006,0.8954 0.8953,0.8954h8.478c0.4909,0 0.8954,-0.4006 0.8954,-0.8954v-14.0896c0,-0.4908 -0.4006,-0.8953 -0.8954,-0.8953z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MembershipIcon;
